(() => {
  function enhance(root) {
    if (root.dataset.agbReady === 'true') return;
    const documentBody = root.querySelector('[data-agb-document]');
    if (!documentBody) return;
    const headings = [...documentBody.querySelectorAll('h2')];
    const contentsHeading = headings.find(h => h.textContent.trim().toLocaleLowerCase('de-DE') === 'inhaltsverzeichnis');
    const sections = headings.filter(h => h !== contentsHeading);
    if (!sections.length) return;
    const entries = sections.map((heading, index) => {
      const raw = heading.textContent.trim();
      const match = raw.match(/^(\d+)([).:\-]?\s+)/);
      const number = match?.[1] || '';
      let id = heading.id;
      if (!id) {
        const base = `suedlis-agb-${number ? number.padStart(2, '0') : `abschnitt-${index + 1}`}`;
        id = base;
        let suffix = 2;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
      }
      heading.setAttribute('tabindex', '-1');
      const next = heading.nextSibling;
      const card = document.createElement('section');
      card.className = 'suedlis-agb-page__card';
      card.setAttribute('aria-labelledby', id);
      heading.before(card);
      card.append(heading);
      const body = document.createElement('div');
      body.className = 'suedlis-agb-page__card-body';
      card.append(body);
      let current = next;
      while (current && !(current.nodeType === 1 && (current.tagName === 'H2' || current.id === 'itkanzlei_txt_copyright'))) {
        const following = current.nextSibling;
        body.append(current);
        current = following;
      }
      if (match && heading.firstChild?.nodeType === 3 && heading.firstChild.textContent.startsWith(match[0])) {
        const textNode = heading.firstChild;
        const remainder = textNode.splitText(match[0].length);
        const punctuation = textNode.splitText(number.length);
        const badge = document.createElement('span');
        badge.className = 'suedlis-agb-page__number';
        textNode.before(badge);
        badge.append(textNode);
        const separator = document.createElement('span');
        separator.className = 'suedlis-agb-page__punctuation';
        punctuation.before(separator);
        separator.append(punctuation);
        const title = document.createElement('span');
        title.className = 'suedlis-agb-page__section-title';
        remainder.before(title);
        let node = remainder;
        while (node) { const following = node.nextSibling; title.append(node); node = following; }
      }
      for (const paragraph of body.querySelectorAll('p')) {
        const label = paragraph.firstElementChild;
        if (!label || !['B', 'STRONG'].includes(label.tagName) || !/^\d+(?:\.\d+)+$/.test(label.textContent.trim())) continue;
        if ([...paragraph.childNodes].slice(0, [...paragraph.childNodes].indexOf(label)).some(n => n.textContent.trim())) continue;
        paragraph.classList.add('suedlis-agb-page__clause');
        label.classList.add('suedlis-agb-page__clause-number');
        const copy = document.createElement('span');
        copy.className = 'suedlis-agb-page__clause-copy';
        while (label.nextSibling) copy.append(label.nextSibling);
        paragraph.append(copy);
      }
      return { heading, id, number, title: match ? raw.slice(match[0].length) : raw };
    });
    const nav = document.createElement('nav');
    nav.className = 'suedlis-agb-page__index';
    nav.setAttribute('aria-label', 'Inhaltsverzeichnis');
    const navHeader = document.createElement('div');
    navHeader.className = 'suedlis-agb-page__index-header';
    const originalList = contentsHeading?.nextElementSibling;
    if (contentsHeading) { contentsHeading.before(nav); navHeader.append(contentsHeading); }
    else {
      documentBody.prepend(nav);
      const title = document.createElement('h2');
      title.textContent = 'Inhaltsverzeichnis';
      title.dataset.agbDecoration = '';
      navHeader.append(title);
    }
    const list = document.createElement('ol');
    list.className = 'suedlis-agb-page__index-list';
    list.style.setProperty('--agb-index-rows', Math.ceil(entries.length / 2));
    for (const entry of entries) {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(entry.id)}`;
      link.setAttribute('aria-label', entry.heading.textContent.trim());
      const number = document.createElement('span');
      number.className = 'suedlis-agb-page__index-number';
      number.textContent = entry.number;
      number.dataset.agbDecoration = '';
      number.setAttribute('aria-hidden', 'true');
      const title = document.createElement('span');
      title.className = 'suedlis-agb-page__index-title';
      title.textContent = entry.title;
      const arrow = document.createElement('span');
      arrow.className = 'suedlis-agb-page__index-arrow';
      arrow.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>';
      arrow.dataset.agbDecoration = '';
      arrow.setAttribute('aria-hidden', 'true');
      link.append(number, title, arrow);
      item.append(link);
      list.append(item, document.createTextNode('\n'));
    }
    nav.append(navHeader, document.createTextNode('\n'), list);
    if (originalList?.tagName === 'OL') originalList.remove();
    root.dataset.agbReady = 'true';
    nav.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      target?.focus({ preventScroll: true });
    });
    if (window.location.hash) {
      try {
        const target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
        if (target && documentBody.contains(target)) target.scrollIntoView({ block: 'start' });
      } catch (_) {}
    }
  }
  document.querySelectorAll('[data-suedlis-agb]').forEach(enhance);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-suedlis-agb]').forEach(enhance));
})();
